<template>
  <div>
    <v-container fluid fill-height>
      <v-row align-center justify-center>
        <v-col md="4" offset-md="4">
          <v-content class="text-center pa-10" v-if="!error">
            <v-progress-circular
              :size="50"
              color="#3497c5"
              indeterminate
            ></v-progress-circular>
            <div class="pb-5 pt-5">
              <p style="color: #666666; font-size: 25px; font-family: Assistant; font-weight: 600;">
                Signing you in with Google...
              </p>
            </div>
          </v-content>
          <v-content class="text-center pa-10" v-else>
            <div class="pt-5">
              <p style="color: #333333; font-size: 25px; font-family: Assistant; font-weight: 600;">
                Sign-in failed
              </p>
              <p style="color: #666666; font-size: 16px; font-family: Assistant;">
                {{ errorMessage }}
              </p>
            </div>
            <v-card-actions class="justify-center pb-5">
              <v-btn color="primary" @click="$router.push('/login')">
                Back to Login
              </v-btn>
            </v-card-actions>
          </v-content>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'GoogleComplete',
  data: () => ({
    error: false,
    errorMessage: 'Please try again or contact support.',
  }),
  mounted() {
    const token = this.$route.query.token;
    const errorParam = this.$route.query.error;

    if (errorParam) {
      this.error = true;
      if (errorParam === 'google_user_not_found') {
        this.errorMessage = 'No account found for this Google email. Please log in with your email and password.';
      } else if (errorParam === 'google_no_email') {
        this.errorMessage = 'Google did not provide an email address. Please try a different sign-in method.';
      } else {
        this.errorMessage = 'Google sign-in was cancelled or failed. Please try again.';
      }
      return;
    }

    if (!token) {
      this.error = true;
      return;
    }

    localStorage.setItem('token', token);
    axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    this.$store.commit('auth_success', token);

    this.getProfile();
  },
  methods: {
    getProfile() {
      this.$store
        .dispatch('profile')
        .then(() => {
          switch (this.$store.getters.level) {
            case 1:
              this.$router.push('/super-admin/companies');
              break;
            case 2:
              this.$router.push('/admin/users');
              break;
            case 7:
              this.$router.push('/course-library');
              break;
            case 8:
              this.$router.push('/invoicing-admin/companies');
              break;
            default:
              this.$router.push('/courses');
              break;
          }
        })
        .catch(() => {
          this.error = true;
          this.errorMessage = 'Failed to load your profile. Please try again.';
          localStorage.removeItem('token');
        });
    },
  },
};
</script>
